import { A as userInfoStore } from '../../../environmentBuilder-f5cc0440.js';
import '../store/chatStore.js';
import '../store/wageringStore.js';
import '../store/roundInfoStore.js';
import '../store/userCountStore.js';
import '../store/gameResultStore.js';
import '../store/resultHashStore.js';
import '../store/userWinBetsStore.js';
import '../store/notificationStore.js';
import '../store/selectedResultInfoStore.js';
import '../enums/GameSpecificTypes.js';
import '../enums/MaxPayoutDataTypes.js';
import '../enums/Chat.js';
import '../enums/GameModes.js';
import '../enums/IconTypes.js';
import '../enums/BetStatus.js';
import '../enums/PopupTypes.js';
import '../enums/ApiVersion.js';
import '../enums/RoundStatus.js';
import '../enums/FreeBetsStatus.js';
import '../enums/SocketEvents.js';
import '../enums/TranslationKeys.js';
import '../enums/TimeoutMaxValue.js';
import '../enums/ApiServiceTypes.js';
import '../enums/EnvironmentTypes.js';
import '../enums/DefaultQueryValues.js';
import '../enums/FreeBetWinningType.js';
import '../enums/DefaultQueryParams.js';
import '../enums/BetHistoryFilterTypes.js';
import '../enums/GameThemeTypes.js';
import '../enums/RequestStatus.js';
import '../enums/FetchDefaultPaths.js';
import '../enums/ResponseCodes.js';
import '../../../tslib.es6-fe064bda.js';
import 'mobx';
import '../classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../services/liveConnection/types.js';
import '../enums/BogLineGameConfig.js';
import './parseQuery.js';
import 'axios';
import '../enums/StatisticsSortingTypes.js';
import '../services/sound/types.js';
import '../services/sound/SoundService.js';
import 'howler';
import '../services/sound/defaultSounds.js';
import '../services/api/types.js';
import '../services/api/BaseApiService.js';
import '../services/ApiServices.js';
import '../polyfill.js';
import '../../../_commonjsHelpers-1a7a244d.js';
import '../../../momentFormat-14fce7b4.js';
import '../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../table-line/t_types/enums/PopupTypes.js';
import './formatDate.js';
import './isMobile.js';
import '../enums/bogGameNames.js';
import './updateHalfBets.js';

/**
 * @desc old name amountExchangerByRate
 * @param bet{Bet}
 */
var exchangeAmountByRate = function (bet) {
    var currentUserId = userInfoStore.userId, rate = userInfoStore.rate, precision = userInfoStore.precision, currencyCode = userInfoStore.currencyCode;
    var amountPrecision = Math.pow(10, +precision) > 1 ? Math.pow(10, +precision) : 100;
    var amount = bet.halfAmount || bet.amount;
    if (+currentUserId === +(bet === null || bet === void 0 ? void 0 : bet.userId) || !bet.userId || (bet === null || bet === void 0 ? void 0 : bet.currencyCode) === currencyCode) {
        return {
            amount: Math.trunc(amount * amountPrecision) / amountPrecision,
            winAmount: Math.trunc((bet === null || bet === void 0 ? void 0 : bet.winAmount) * amountPrecision) / amountPrecision,
        };
    }
    var coinAmount = bet.halfAmount || (bet === null || bet === void 0 ? void 0 : bet.coinAmount);
    return {
        amount: Math.trunc((coinAmount / +rate) * amountPrecision) / amountPrecision,
        winAmount: Math.trunc(((bet === null || bet === void 0 ? void 0 : bet.winCoinAmount) / +rate) * amountPrecision) / amountPrecision,
    };
};

export { exchangeAmountByRate };
